export const normalizeApiError = errorResponse => ({
	'status': errorResponse.httpStatus || errorResponse.statusCode || 500,
    'code': errorResponse.errorCode || errorResponse.code || 'UNKNOWN_ERROR',
    'message': errorResponse.errorMessage || errorResponse.message || 'Error desconocido'
});



// WEBPACK FOOTER //
// ./src/utils/error/index.js